module.exports = __webpack_public_path__ + "static/media/6347.80a46d7d.svg";